var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "limits-list" },
    [
      _c("div", { staticClass: "container-header" }, [
        _c("div", { staticClass: "container-header__title" }, [
          _vm._v(_vm._s(_vm.i18n.lim_limits_requests()))
        ])
      ]),
      _vm._v(" "),
      _c(
        "md-table",
        { staticClass: "container container_40 limits-list__table scrollbar" },
        [
          _vm.list.length
            ? [
                _c(
                  "md-table-row",
                  { staticClass: "limits-list__row" },
                  [
                    _c("md-table-head", [_vm._v(_vm._s(_vm.i18n.lim_date()))]),
                    _vm._v(" "),
                    _c("md-table-head", [
                      _vm._v(_vm._s(_vm.i18n.lbl_request_type()))
                    ]),
                    _vm._v(" "),
                    _c("md-table-head", [_vm._v(_vm._s(_vm.i18n.lim_state()))]),
                    _vm._v(" "),
                    _c("md-table-head", [_vm._v(_vm._s(_vm.i18n.lim_asset()))]),
                    _vm._v(" "),
                    _c("md-table-head")
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._l(_vm.list, function(request, i) {
                  return [
                    _c(
                      "md-table-row",
                      { key: i, staticClass: "limits-list__table-row" },
                      [
                        _c(
                          "md-table-cell",
                          {
                            staticClass: "limits-list__table-cell text_medium"
                          },
                          [_vm._v(_vm._s(_vm.i18n.d(request.createdAt)))]
                        ),
                        _vm._v(" "),
                        _c(
                          "md-table-cell",
                          {
                            staticClass: "limits-list__table-cell text_medium"
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.LIMITS_REQUEST_TYPE_STR[
                                  _vm.get(request, "details.requestType", "-")
                                ]
                              )
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "md-table-cell",
                          {
                            staticClass: "limits-list__table-cell text_medium"
                          },
                          [_vm._v(_vm._s(_vm.getState(request.state)))]
                        ),
                        _vm._v(" "),
                        _c(
                          "md-table-cell",
                          {
                            staticClass: "limits-list__table-cell text_medium"
                          },
                          [_vm._v(_vm._s(_vm.get(request, "tokenCode", "-")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "md-table-cell",
                          {
                            staticClass: "limits-list__table-cell text_medium"
                          },
                          [
                            _c(
                              "md-button",
                              {
                                attrs: {
                                  disabled:
                                    request.state !==
                                    _vm.REQUEST_STATES_STR.rejected
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.viewRequest(request)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.i18n.lim_upload_documents_btn())
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                })
              ]
            : [
                _c(
                  "div",
                  { staticClass: "limits-list__no-requests" },
                  [
                    _c("md-icon", { staticClass: "md-size-4x" }, [
                      _vm._v("trending_up")
                    ]),
                    _vm._v(" "),
                    _c(
                      "h2",
                      { staticClass: "limits-list__no-requests-header" },
                      [_vm._v(_vm._s(_vm.i18n.lim_no_changing_requests()))]
                    ),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(_vm._s(_vm.i18n.lim_no_changing_requests_desc()))
                    ])
                  ],
                  1
                )
              ]
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "btn-wrap margin-top" },
        [
          _c(
            "md-button",
            {
              staticClass: "btn md-primary",
              on: {
                click: function($event) {
                  return _vm.loadNext()
                }
              }
            },
            [_vm._v(_vm._s(_vm.i18n.lbl_more()))]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.isUploadingDocs
        ? _c(
            "modal",
            {
              attrs: { maxWidth: "30rem" },
              on: {
                "close-request": function($event) {
                  _vm.isUploadingDocs = false
                }
              }
            },
            [
              _c("documents-uploader", {
                attrs: { request: _vm.selectedRequest },
                on: {
                  "close-request": function($event) {
                    _vm.isUploadingDocs = false
                  }
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a6369a6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a6369a6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/limits/Limits.List.vue
// module id = EYv0
// module chunks = 1